/**
 * @class passwordConstants
 *
 * do not use the tableConstantFactory because we only need a limited set of constants
 */
const passwordConstants = {};
passwordConstants.PASSWORD_RULES_CHECK = 'PASSWORD_RULES_CHECK';
passwordConstants.PASSWORD_RULES_RESET = 'PASSWORD_RULES_RESET';
export default passwordConstants;